import { Anchor } from 'antd'
import React, { FunctionComponent } from 'react'
import { TabKey } from '@/components/kol/hooks/use-section-tabs'
import { KOL_DETAIL_SECTION_TABS_HEIGHT } from '@/components/kol/navigation/section-tabs'
import useHeaderHeight from '@/hooks/use-header-height'

interface SectionAnchorProps {
  tabs: TabKey[]
  onChange: (value: string) => void
}

const SectionAnchor: FunctionComponent<SectionAnchorProps> = ({
  tabs,
  onChange,
}) => {
  const headerHeight = useHeaderHeight()

  return (
    <div style={{ display: 'none' }}>
      <Anchor
        offsetTop={headerHeight + KOL_DETAIL_SECTION_TABS_HEIGHT}
        onChange={(activeAnchor): void => {
          onChange(activeAnchor.replace('#', ''))
        }}
      >
        {tabs.map((tabKey) => {
          return <Anchor.Link href={`#${tabKey}`} key={tabKey} title='' />
        })}
      </Anchor>
    </div>
  )
}

export default SectionAnchor
